/**
 * Maps human-readable keys to Framer XLIFF translation unit IDs.
 * Used by the careers page to look up translations from messages/{locale}.json.
 *
 * To find new keys: search messages/en.json for the English text,
 * then add the Framer ID here.
 */
export const careersKeys = {
  // Hero
  pageLabel: "pageLabel", // "Join our team"
  heading: "careersHeading", // "Transform healthcare, start with your career"
  subtitle: "subtitle", // "We're bringing premium concierge healthcare to the rest of us. With AI, of course."

  // Open roles section
  openRolesLabel: "openRolesLabel", // "Open roles"

  // Values section
  valueTrustedSidekickTitle: "valueTrustedSidekickTitle", // "Trusted sidekick"
  valueTrustedSidekickDesc: "valueTrustedSidekickDesc", // "It's about your health..."
  valueAlwaysThereTitle: "valueAlwaysThereTitle", // "Always there"
  valueAlwaysThereDesc: "valueAlwaysThereDesc", // "We see humans, not patients..."
  valueBetterEveryDayTitle: "valueBetterEveryDayTitle", // "Better every day"
  valueBetterEveryDayDesc: "valueBetterEveryDayDesc", // "We learn from each customer..."
  valueActionablyProactiveTitle: "valueActionablyProactiveTitle", // "Actionably proactive"
  valueActionablyProactiveDesc: "valueActionablyProactiveDesc", // "We put you in the driver's seat..."
  valueGrittyTitle: "valueGrittyTitle", // "Gritty"
  valueGrittyDesc: "valueGrittyDesc", // "Health care should replace sick care..."
  valueThinkBigTitle: "valueThinkBigTitle", // "Think big"
  valueThinkBigDesc: "valueThinkBigDesc", // "What we do needs to work for everyone..."

  // Hero image
  heroImageAlt: "heroImageAlt", // "Ahead Health team"

  // Hero CTAs
  seeOpenRoles: "seeOpenRoles", // "See open roles"
  sendOpenApplication: "sendOpenApplication", // "Send open application"

  // Open roles section (continued)
  openRolesHeading: "openRolesHeading", // "See what we're building towards"
  openRolesBody: "openRolesBody", // "We're a small, high-output team. Every hire has outsized impact."
  applyNow: "applyNow", // "Apply now"
  dontSeeAFit: "dontSeeAFit", // "Don't see a fit?"
  sendAnOpenApplication: "sendAnOpenApplication", // "Send an open application"

  // Values / culture section
  howWeWorkLabel: "howWeWorkLabel", // "How we work"
  whatWeBelieveIn: "whatWeBelieveIn", // "What we believe in"
  valuesBody: "valuesBody", // "We're bringing premium concierge healthcare to the rest of us. With AI, of course."

  // Backed by / investors section
  backedByLabel: "backedByLabel", // "Backed by AI & healthtech experts"
  backedByHeading: "backedByHeading", // "World-class angels, advisors, and top European athletes"
  backedByBody: "backedByBody", // "Funded and supported by amazing founders & execs from Hugging Face, Cradle, DeepMind, GE, Stanford Medicine, Coda, and more."

  // Job detail — role grid
  yourRoleLabel: "yourRoleLabel", // "YOUR ROLE"
  yourRoleHeading: "yourRoleHeading", // "Build from the ground up"

  // Job detail — bento blocks
  bentoHeadline: "bentoHeadline", // "Build Europe's leading preventative health platform"
  bentoSubtitle: "bentoSubtitle", // "Transform how people understand and manage their health"
  bentoZurich: "bentoZurich", // "Zürich"
  bentoZurichCaption: "bentoZurichCaption", // "Our center for innovation and healthcare excellence"

  // FAQ section
  faqLabel: "faqLabel", // "FAQ"
  faqHeading: "faqHeading", // "Frequently asked questions"
} as const
